import { IconProps } from '.';

function FolderIcon({ style, className }: IconProps) {
  return (
    <svg
      width="20" 
      height="20" 
      viewBox="0 0 16 17"
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      style={style}
    >
      <title>FolderIcon</title>
      <path fillRule="evenodd" clipRule="evenodd" d="M2.5 3.78467H8.91802L9.19075 4.78467H2.5V3.78467ZM1.5 4.78496V3.78467C1.5 3.23238 1.94772 2.78467 2.5 2.78467H8.91802C9.36897 2.78467 9.76413 3.08649 9.88279 3.52155L10.2273 4.78467H15.475C16.1127 4.78467 16.5955 5.34699 16.4839 5.9597L15.2087 12.9597C15.1217 13.437 14.6965 13.7847 14.1997 13.7847H2.80027C2.30351 13.7847 1.87829 13.437 1.79134 12.9597L0.516104 5.9597C0.405947 5.35504 0.874743 4.79944 1.5 4.78496ZM1.52503 5.78467L2.80027 12.7847H14.1997L15.475 5.78467H10.5H1.52503Z" fill="currentColor"/>
    </svg>
  );
}

export default FolderIcon;
